import { Navigate } from "react-router-dom";
import { usePermissions } from "../../contexts/PermissionContext";
import { useStateContext } from "../../contexts/ContextProvider";
import { findFirstAccessibleRoute, FALLBACK_ROUTE } from "../../config/routePermissions";

/**
 * Composant de redirection intelligente.
 * Redirige l'utilisateur vers la première page accessible selon ses permissions.
 * Utilisé pour la route racine "/" après le login.
 */
export default function SmartRedirect() {
    const { hasPermission, hasAnyPermission, hasRole, isSuperAdmin } = usePermissions();
    const { isUserLoading, user, currentFacility } = useStateContext();

    // Attendre que l'utilisateur soit chargé
    if (isUserLoading || user.id === 0) {
        return null;
    }

    // Super admin redirigé vers le dashboard
    if (isSuperAdmin) {
        return <Navigate to="/dashboard" replace />;
    }

    // Agent d'entretien : page d'accueil = "Mes chambres"
    if (hasRole('housekeeping-agent')) {
        return <Navigate to="/housekeeping/my-rooms" replace />;
    }

    // Technicien : page d'accueil = les signalements de maintenance
    if (hasRole('housekeeping-technician')) {
        return <Navigate to="/housekeeping/maintenance" replace />;
    }

    // Première route accessible dans l'ordre de priorité
    const route = findFirstAccessibleRoute(currentFacility, (perm) => (
        Array.isArray(perm) ? hasAnyPermission(perm) : hasPermission(perm)
    ));
    if (route) {
        return <Navigate to={route} replace />;
    }

    return <Navigate to={FALLBACK_ROUTE} replace />;
}
